import React from 'react';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import LogoHeader from './layout/LogoHeader';
import Typo from '../teal-react/components/atoms/Typo';
import Loading from '../teal-react/components/molecules/Loading';
import Utils from '../teal-react/utils';
import IsoImage from './layout/IsoImage';
import PageStrut from '../teal-react/components/atoms/PageStrut';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import { useQcTestSummary } from '../graphql/queries';
import { QUALITY_CONTROL_AGENT } from '../Constants';

interface CertificateViewerProps {
  qc_id: number;
  type: 'COA' | 'COC' | 'COO';
}
const Address = () => {
  return (
    <div className="tc">
      <div>PLUSCO, INC.</div>
      <div>14518 Henry Rd., Houston TX 77060</div>
      <div>Phone - 713-880-0316</div>
      <div>Fax - 713-880-4237</div>
    </div>
  );
};
const CertificateViewer = ({ qc_id, type }: CertificateViewerProps) => {
  const strutRef = React.useRef(null);
  const { data } = useQcTestSummary(qc_id);
  if (!data) {
    return <Loading />;
  }
  const qc = data.qc[0];
  const title =
    type === 'COA'
      ? 'CERTIFICATE OF ANALYSIS'
      : type === 'COC'
      ? 'CERTIFICATE OF CONFORMANCE'
      : 'CERTIFICATE OF ORIGIN';

  return (
    <div ref={strutRef}>
      <SimpleCard>
        <SimpleGrid
          spacing={3}
          items={[
            {
              content: <LogoHeader />,
            },
            {
              content: <Address />,
            },
            {
              content: (
                <div className="tc">
                  <strong>{Typo.body(title)}</strong>
                </div>
              ),
            },
            {
              content: (
                <table className="coa-table">
                  <tbody>
                    <tr>
                      <th>Lot/Batch Number:</th>
                      <td>{qc.qc_code}</td>
                    </tr>
                    <tr>
                      <th>Shipped From:</th>
                      <td>PLUSCO, INC.</td>
                    </tr>
                    {type === 'COO' ? (
                      <>
                        <tr>
                          <th>Country of Origin:</th>
                          <td>United States</td>
                        </tr>
                      </>
                    ) : null}
                    {type === 'COC' ? (
                      <tr>
                        <th>Manufacture Date:</th>
                        <td>
                          {Utils.date.formatDate(data.qcTestSummary.date)}
                        </td>
                      </tr>
                    ) : null}

                    {type !== 'COA' ? (
                      <>
                        <tr>
                          <th>Shelf Life:</th>
                          <td>{qc.product.shelflife} (unopened container)</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <th>Product Code:</th>
                      <td>{qc.product.code}</td>
                    </tr>
                    <tr>
                      <th>Product Description:</th>
                      <td>{qc.product.name}</td>
                    </tr>
                  </tbody>
                </table>
              ),
            },
          ]}
        />
        <table
          className="coa-table"
          style={{ width: '100%', margin: '40px 0 80px' }}
        >
          <thead>
            <tr>
              <th>TESTING</th>
              <th>Specifications</th>
              <th>Results</th>
            </tr>
            <tr>
              <th colSpan={3}>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {data.qcTestSummary
              .filter((row: any) => Boolean(row.coa))
              .map((row: any) => {
                return (
                  <tr key={row.qc_test_id}>
                    <th>{row.name}</th>
                    <td>{row.parameter}</td>
                    <td>{row.result}</td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3} style={{ height: 80 }}>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <strong>
                  <u>{QUALITY_CONTROL_AGENT}</u>
                </strong>
              </td>
              <td>
                <u>
                  {Utils.date
                    .asMoment(qc.date)
                    ?.add(1, 'days')
                    .format('MM/DD/YY')}
                </u>
              </td>
            </tr>
            <tr>
              <td>{QUALITY_CONTROL_AGENT}, CQA</td>
              <td>Date</td>
            </tr>
          </tfoot>
        </table>
        <PageStrut id={`${type}${qc_id}`} parentRef={strutRef} />
        <IsoImage />
      </SimpleCard>
    </div>
  );
};

export default CertificateViewer;
